"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructVariables = void 0;
const constructVariables = ({ params = {} }, props) => {
    return {
        variables: Object.keys(params).reduce((p, c) => (Object.assign(Object.assign({}, p), { [c]: props[c] })), {}),
    };
};
exports.constructVariables = constructVariables;
exports.default = exports.constructVariables;
